import { ParserError } from '@app/utils/filter/parser/parser-error';
import { Term } from '@app/utils/filter/terms/term';

export type ParseResult = NegativeParse | PositiveParse;

interface NegativeParse {
  error: ParserError;
  terms: [];
}

interface PositiveParse {
  error: undefined;
  terms: Term[];
}

export function isNegativeParse(parse: ParseResult): parse is NegativeParse {
  return parse.error !== undefined;
}

export function isPositiveParse(parse: ParseResult): parse is PositiveParse {
  return parse.error === undefined;
}
